export const dataHooks = {
  tooltip: 'infoicon-tooltip',
};
